import { getBooleanOperatorValuesForCollectionFilter } from '../../../services/filtering/collection-filter-mapping-service';
import { BillToParty, ACCOUNT } from '../../../enums/bill-to-party';

const getMappedFilter = (appliedFilter) => {
  const criteria = getBooleanOperatorValuesForCollectionFilter(appliedFilter);
  const {
    criterionMeta: { value: billToParty },
    criterionArgumentValue,
  } = appliedFilter;

  if (billToParty === ACCOUNT) {
    return {
      column: 'SellerProviderId',
      values: [criterionArgumentValue],
      isIn: criteria.isIn,
      isNull: criteria.isNull,
    };
  }

  return {
    column: 'BillToParty',
    values: [BillToParty.indexOf(billToParty)],
    isIn: criteria.isIn,
    isNull: criteria.isNull,
  };
};

const shippingAccountMapper = (appliedFilter) => {
  const mappedFilter = getMappedFilter(appliedFilter);
  return {
    normalizableCollectionFilters: [mappedFilter],
  };
};

export default shippingAccountMapper;
